const ar = () => {
    return {
        arias: {
            stepper: {
                start: "أنت في المرحلة",
                end: "من"
            },
            back_button: "رجوع",
            cover_selection: "غلاف رقم",
            image_to_load: "تحميل صورة",
            image_load: "جاري تحميل الصورة",
            loaded_image: "الصورة المحملة",
            customer_image: "صورة العميل",
            exampleDialogTitle: "مثال على الصور",
            payDialogTitle: "يجب اختيار نوع الكتاب",
            templateInfoDialogTitle: "معلومات عن القالب",
            next: "التالي",
            prev: "عرض المزيد من الخيارات",
            choose_template: "قائمة المواضيع",
            close: "إغلاق",
            more_info_about_template: "عرض معلومات إضافية عن الموضوع",
            levels: {
                level: "ويجب عليك",
                upload_image: "تحميل صورة",
                fill_info: "ملء البيانات ذات الصلة للعميل",
                choose_appearance: "اختيار المظهر",
                choose_template: "اختيار القالب"
            },
            book_image_preview: "معاينة صورة الصفحة",
            preview_book: {
                cover: "نموذج لصفحة الغلاف",
                image: "نموذج لصفحة الصورة",
                text: "نموذج لصفحة النص",
                mini_image: "نموذج لصورة رقم"
            }
        },
        general: {
            next: "المرحلة التالية",
            pageTitle: "إنشاء كتاب"
        },
        error: {
            error_upload: "يجب عليك اختيار صورة للمتابعة",
            error_stage: "يجب عليك ملء جميع التفاصيل للمتابعة",
            error_creation: "حدثت مشكلة أثناء إنشاء الكتاب..",
            error_template: "يجب عليك اختيار قالب قبل المتابعة لإنشاء الكتاب!",
            many_faces: "مرحبًا، تم التعرف على أكثر من وجه في الصورة، حاول مرة أخرى"
        },
        click_me: "اضغط عليّ",
        choose: "اختيار",
        i_want_this_template: "أريد هذه القصة",
        shop_now: "اشترِ الآن",
        last_seen: "آخر ظهور"
    };
};

export default ar;
